import Avenue from '../../Media/Logo Ciputra Cibubur/Avenue.png'
import Marquette from '../../Media/Logo Ciputra Cibubur/Marquette.png'



const commercialsimages =[
Avenue, Marquette
]

export default commercialsimages;